import { render } from "./GeoComuni.vue?vue&type=template&id=014496a6&scoped=true"
import script from "./GeoComuni.vue?vue&type=script&lang=js"
export * from "./GeoComuni.vue?vue&type=script&lang=js"

import "./GeoComuni.vue?vue&type=style&index=0&id=014496a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014496a6"]])

export default __exports__